module.exports = __webpack_public_path__ + "img/proList2_27_10.2283da04.jpg";